/**
 *  CharacterScene
 *
 *  Created by Legman on 27/03/2016.
 *
 */

import Common   from "../Common";

/**
 * @class
 * @extends p3.Scene
 */
export default class CharacterScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {p3.Button}
         * @private
         */
        this._raceButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._homeButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._muteButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._nextButton = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._previousButton = null;

        /**
         * @member {number}
         * @private
         */
        this._index = Common.playerDriverId;

        /**
         * @member {PIXI.Container}
         * @private
         */
        this._nameplate = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._vehicle = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._driver = null;

        /**
         * @type {PIXI.Sprite}
         * @private
         */
        this._sidekick = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("ui_char_bg"));
        this.addChild(bg);

        let holder = new PIXI.Container();
        holder.x = Common.STAGE_WIDTH * 0.5 - 100;
        holder.y = 480;
        this.addChild(holder);

        this._vehicle = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._vehicle.x = Common.STAGE_WIDTH * 0.5 - 100;
        this._vehicle.y = 480;
        this._vehicle.anchor = new PIXI.Point(0.5, 0.5);
        holder.addChild(this._vehicle);

        this._vehicle.shadow = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._vehicle.shadow.anchor = new PIXI.Point(0.5, 0.5);
        this._vehicle.shadow.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        holder.addChildAt(this._vehicle.shadow, this._vehicle.parent.getChildIndex(this._vehicle));

        holder = new PIXI.Container();
        holder.y = p3.View.height;
        this.addChild(holder);

        this._sidekick = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._sidekick.anchor = new PIXI.Point(0.5, 1);
        holder.addChild(this._sidekick);

        this._driver = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._driver.anchor = new PIXI.Point(0.5, 1);
        holder.addChild(this._driver);

        this._nameplate = new PIXI.Sprite(assets.getTexture("ui_char_name_bg"));
        this._nameplate.x = Common.STAGE_WIDTH * 0.5 - 80;
        this._nameplate.y = 140;
        this._nameplate.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._nameplate);

        if (language === "ar") {
            this._nameplate.first = new PIXI.Text("", {
                fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6});
            this._nameplate.first.y = 3;
            this._nameplate.first.pivot.x = 160;
            this._nameplate.first.pivot.y = Math.round(this._nameplate.first.height * 0.8);
            this._nameplate.addChild(this._nameplate.first);
        } else {
            this._nameplate.first = new PIXI.BitmapText("", font(32, "center"));
            this._nameplate.first.y = 6;
            this._nameplate.first.pivot.x = 200 + 40;
            this._nameplate.first.pivot.y = Math.round(this._nameplate.first.textHeight * 0.8);
            this._nameplate.addChild(this._nameplate.first);
        }

        if (language === "ar") {
            this._nameplate.second = new PIXI.Text("", {
                fontSize: "36px", fontFamily: "Noto Kufi Arabic", fill: 0xFFFFFF, align: "center", padding: 6});
            this._nameplate.second.y = 3;
            this._nameplate.second.pivot.x = 120;
            this._nameplate.addChild(this._nameplate.second);
        } else {
            this._nameplate.second = new PIXI.BitmapText("", font(32, "center"));
            this._nameplate.second.y = 6;
            this._nameplate.second.pivot.x = 120 + 40;
            this._nameplate.addChild(this._nameplate.second);
        }

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_big_out");
        states.over = assets.getTexture("ui_btn_big_over");
        states.down = assets.getTexture("ui_btn_big_down");
        states.icon = assets.getTexture("ui_icon_play");

        this._raceButton = new p3.Button(states);
        this._raceButton.visible = false;
        this._raceButton.interactive = false;
        this._raceButton.overSoundName = "sfx_btn_rollover_00";
        this._raceButton.clickSoundName = "sfx_btn_press_00";
        this._raceButton.signals.click.add(this.onRaceButtonClick, this);
        this.addChild(this._raceButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_home");

        this._homeButton = new p3.Button(states);
        this._homeButton.visible = false;
        this._homeButton.interactive = false;
        this._homeButton.overSoundName = "sfx_btn_rollover_00";
        this._homeButton.clickSoundName = "sfx_btn_press_00";
        this._homeButton.signals.click.add(this.onHomeButtonClick, this);
        this.addChild(this._homeButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_out");
        states.over = assets.getTexture("ui_btn_over");
        states.down = assets.getTexture("ui_btn_down");
        states.icon = assets.getTexture("ui_icon_sound_on");
        states.iconAlt = assets.getTexture("ui_icon_sound_off");

        this._muteButton = new p3.MuteButton(states);
        this._muteButton.visible = false;
        this._muteButton.interactive = false;
        this._muteButton.overSoundName = "sfx_btn_rollover_00";
        this._muteButton.clickSoundName = "sfx_btn_press_00";
        this.addChild(this._muteButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_arrow_r");

        this._nextButton = new p3.Button(states);
        this._nextButton.visible = false;
        this._nextButton.interactive = false;
        this._nextButton.overSoundName = "sfx_btn_rollover_00";
        this._nextButton.clickSoundName = "sfx_btn_press_00";
        this._nextButton.signals.click.add(this.onNextButtonClick, this);
        this.addChild(this._nextButton);

        states = new p3.ButtonStates();
        states.normal = assets.getTexture("ui_btn_arrow_l");

        this._previousButton = new p3.Button(states);
        this._previousButton.visible = false;
        this._previousButton.interactive = false;
        this._previousButton.overSoundName = "sfx_btn_rollover_00";
        this._previousButton.clickSoundName = "sfx_btn_press_00";
        this._previousButton.signals.click.add(this.onPreviousButtonClick, this);
        this.addChild(this._previousButton);

        this.showCharacter(this._index);
    }

    destroy() {
        const input = Common.input;
        input.signals.swipeLeft.remove(this.onSwipeLeft, this);
        input.signals.swipeRight.remove(this.onSwipeRight, this);

        TweenMax.killTweensOf(this._driver.scale);
        TweenMax.killTweensOf(this._sidekick.scale);

        super.destroy();
    }

    appear() {
        super.appear();

        const input = Common.input;
        input.signals.swipeLeft.add(this.onSwipeLeft, this);
        input.signals.swipeRight.add(this.onSwipeRight, this);

        Common.audio.playMusic("music_garage_loop_00");
        Common.audio.playSound("sfx_muttly_giggle_00");
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        this._homeButton.scale = new PIXI.Point();
        TweenMax.to(this._homeButton.scale, 0.4, {
            delay: 0.1,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._homeButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._homeButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._muteButton.scale = new PIXI.Point();
        TweenMax.to(this._muteButton.scale, 0.4, {
            delay: 0.1 + 0.06,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._muteButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._muteButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._previousButton.scale = new PIXI.Point();
        TweenMax.to(this._previousButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 2,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [3],
            onStart: function() {
                this._previousButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._previousButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._nextButton.scale = new PIXI.Point();
        TweenMax.to(this._nextButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 2,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [3],
            onStart: function() {
                this._nextButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._nextButton.interactive = true;
            },
            onCompleteScope: this
        });

        this._raceButton.scale = new PIXI.Point();
        TweenMax.to(this._raceButton.scale, 0.4, {
            delay: 0.1 + 0.06 * 4,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [4],
            onStart: function() {
                this._raceButton.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                this._raceButton.interactive = true;
            },
            onCompleteScope: this
        });
    }

    resize() {
        this.x = (p3.View.width - Common.STAGE_WIDTH) * 0.5;

        this._driver.parent.x = Common.STAGE_WIDTH * 0.5 + p3.View.width * 0.24;

        this._raceButton.x = Common.STAGE_WIDTH * 0.5;
        this._raceButton.y = p3.View.height - 120;

        this._homeButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
        this._homeButton.y = 100;

        this._muteButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._muteButton.y = 100;

        this._nextButton.x = (Common.STAGE_WIDTH + p3.View.width) * 0.5 - 100;
        this._nextButton.y = Common.STAGE_HEIGHT * 0.5;

        this._previousButton.x = (Common.STAGE_WIDTH - p3.View.width) * 0.5 + 100;
        this._previousButton.y = Common.STAGE_HEIGHT * 0.5;
    }

    update() {
        const input = Common.input;
        if (input.isKeyPressed(37)) {
            this.onPreviousButtonClick(null);
        }
        if (input.isKeyPressed(39)) {
            this.onNextButtonClick(null);
        }
        if (input.isKeyPressed(32)) {
            this.onRaceButtonClick(null);
        }
    }

    /**
     * @param {number} index
     */
    showCharacter(index) {
        const assets = Common.assets;
        const character = Common.config.characters[index];

        this._nameplate.first.text = translate(character.names.first);
        this._nameplate.second.text = translate(character.names.second);

        this._driver.texture = assets.getTexture(character.driver.texture);
        this._driver.x = character.driver.offset.x;
        this._driver.y = character.driver.offset.y;

        if (character.sidekick) {
            this._sidekick.texture = assets.getTexture(character.sidekick.texture);
            this._sidekick.x = character.sidekick.offset.x;
            this._sidekick.y = character.sidekick.offset.y;
        } else {
            this._sidekick.texture = PIXI.Texture.EMPTY;
        }

        this._vehicle.texture = assets.getTexture(character.vehicle.texture);
        this._vehicle.x = character.vehicle.offset.x;
        this._vehicle.y = character.vehicle.offset.y;

        this._vehicle.shadow.texture = assets.getTexture(character.vehicle.shadow.texture);
        this._vehicle.shadow.x = this._vehicle.x + character.vehicle.shadow.offset.x;
        this._vehicle.shadow.y = this._vehicle.y + character.vehicle.shadow.offset.y;

        // fade vehicle
        this._vehicle.alpha = 0;
        TweenMax.killTweensOf(this._vehicle);
        TweenMax.to(this._vehicle, 0.32, {
            alpha: 1,
            ease: Power1.easeInOut,
            onStart: function() {
                Common.audio.playSound("sfx_btn_nextcar_00");
            }
        });

        let tl = new TimelineMax();

        // bounce vehicle
        let to = this._vehicle.y;
        this._vehicle.y = this._vehicle.y - 160;
        tl.append(TweenMax.to(this._vehicle, 0.4, {
            y: to,
            ease: Power2.easeIn,
            onComplete: function() {
                TweenMax.killTweensOf(this._vehicle.scale);
                TweenMax.to(this._vehicle.scale, 0.12, {
                    delay: 0.01,
                    y: 0.96,
                    ease: Power1.easeInOut,
                    yoyo: true,
                    repeat: 1,
                });

                Common.audio.playSound("sfx_car_land_00");
            },
            onCompleteScope: this
        }));
        tl.append(TweenMax.to(this._vehicle, 0.1, {
            y: to - 18,
            ease: Power1.easeOut,
        }));
        tl.append(TweenMax.to(this._vehicle, 0.08, {
            y: to,
            ease: Power1.easeIn,
        }));

        // fade shadow
        this._vehicle.shadow.alpha = 0;
        TweenMax.killTweensOf(this._vehicle.shadow);
        TweenMax.to(this._vehicle.shadow, 0.4, {
            delay: 0.04,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // slide driver
        to = this._driver.x;
        this._driver.x = this._driver.x + 800;
        TweenMax.killTweensOf(this._driver);
        TweenMax.to(this._driver, 0.4, {
            delay: 0.3,
            x: to,
            ease: Back.easeOut,
            easeParams: [1]
        });

        // fade driver
        this._driver.alpha = 0;
        TweenMax.to(this._driver, 0.2, {
            delay: 0.3,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // bounce driver
        this._driver.rotation = 0.14;
        TweenMax.to(this._driver, 0.8, {
            delay: 0.46,
            rotation: 0,
            ease: Elastic.easeOut,
            easeParams: [1]
        });

        // breath driver
        this._driver.scale = new PIXI.Point(1, 1);
        TweenMax.killTweensOf(this._driver.scale);
        TweenMax.to(this._driver.scale, 1, {
            y: 0.96,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });
        TweenMax.to(this._driver.scale, 1.1, {
            y: 0.98,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });

        // slide sidekick
        to = this._sidekick.x;
        this._sidekick.x = this._sidekick.x + 800;
        TweenMax.killTweensOf(this._sidekick);
        TweenMax.to(this._sidekick, 0.4, {
            delay: 0.5,
            x: to,
            ease: Back.easeOut,
            easeParams: [1]
        });

        // fade sidekick
        this._sidekick.alpha = 0;
        TweenMax.to(this._sidekick, 0.2, {
            delay: 0.5,
            alpha: 1,
            ease: Power1.easeInOut
        });

        // bounce sidekick
        this._sidekick.rotation = 0.14;
        TweenMax.to(this._sidekick, 0.8, {
            delay: 0.66,
            rotation: 0,
            ease: Elastic.easeOut,
            easeParams: [1]
        });

        // breath sidekick
        this._sidekick.scale = new PIXI.Point(1, 1);
        TweenMax.killTweensOf(this._sidekick.scale);
        TweenMax.to(this._sidekick.scale, 1, {
            delay: 0.2,
            y: 0.96,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });
        TweenMax.to(this._sidekick.scale, 1.1, {
            delay: 0.2,
            y: 0.98,
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        });

        // pop nameplate
        this._nameplate.scale = new PIXI.Point(0, 0);
        TweenMax.killTweensOf(this._nameplate.scale);
        TweenMax.to(this._nameplate.scale, 0.34, {
            delay: 0.24,
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2]
        });
    }

    /**
     * @param {p3.Button} button
     */
    onNextButtonClick(button) {
        if (++ this._index >= Common.config.characters.length) {
            this._index = 0;
        }
        this.showCharacter(this._index);
    }

    /**
     * @param {p3.Button} button
     */
    onPreviousButtonClick(button) {
        if (-- this._index < 0) {
            this._index = Common.config.characters.length - 1;
        }
        this.showCharacter(this._index);
    }

    /**
     * @param {p3.Button} button
     */
    onRaceButtonClick(button) {
        this._homeButton.interactive = false;
        this._raceButton.interactive = false;

        const id = Common.config.characters[this._index].id;
        this.signals.next.dispatch(this, id);

        Common.audio.playSound("sfx_carsrush_by_00");
    }

    /**
     * @param {p3.Button} button
     */
    onHomeButtonClick(button) {
        this._homeButton.interactive = false;
        this._raceButton.interactive = false;

        this.signals.home.dispatch(this);

        Common.audio.playSound("sfx_whistle_fall_00");
    }

    onSwipeLeft() {
        this.onPreviousButtonClick(null);
    }

    onSwipeRight() {
        this.onNextButtonClick(null);
    }
}

